import { cn } from "@/lib/utils";

const initialsOf = (name: string) =>
  name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export const TestimonialAvatar = ({
  name,
  src,
  size = 48,
  className,
}: {
  name: string;
  src?: string | null;
  size?: number;
  className?: string;
}) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        loading="lazy"
        className={cn("rounded-full object-cover object-top flex-shrink-0", className)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className={cn(
        "rounded-full bg-accent/15 flex items-center justify-center flex-shrink-0",
        className
      )}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span className="font-mono text-xs text-accent font-semibold">{initialsOf(name)}</span>
    </div>
  );
};
